import React from 'react';
import { WidgetType } from '../../types/api/ElementType';
import { getContextSectionWidget } from '../Context/ContextSection';

export type ContentMultiColumnSection<TWidgets = any> = { one: { widgets: TWidgets[] }, two: { widgets: TWidgets[] } };

type ContentMultiColumnProps = {
  section: ContentMultiColumnSection;
};

// allowedWidgets = all widgets of the ContextSection on the home page, see SON-17711
const allowedWidgets = [
  WidgetType.applibraryglobal,
  WidgetType.pendingAccessLevelRequests,
  WidgetType.currentannouncementsinbox,
  WidgetType.externallinks,
  WidgetType.genericsearchlist,
  WidgetType.latestadditions,
  WidgetType.upcomingevents,
  WidgetType.rssfeed,
  WidgetType.latestforumposts,
  WidgetType.calendar,
];

export function ContentMultiColumn({ section }: ContentMultiColumnProps) {
  if (section && (section.one || section.two)) {
    const oneWidgets = [...section.one.widgets];
    const twoWidgets = [...section.two.widgets];
    return (
      <div className="content-multi-column">
        <div className="content-multi-column__column-one">
          { section.one
            ? oneWidgets.filter(widget => allowedWidgets.includes(widget.elementType)).map(getContextSectionWidget)
            : null }
        </div>
        <div className="content-multi-column__column-two">
          { section.two
            ? twoWidgets.filter(widget => allowedWidgets.includes(widget.elementType)).map(getContextSectionWidget)
            : null }
        </div>
      </div>);
  }
}
